import { Component, OnInit } from '@angular/core';
import { AdminServiceService } from '../../service/admin-service.service';
import { UiService } from '../../service/ui.service';
import { LocationComponent } from '../location/location.component';

@Component({
  selector: 'app-cities',
  templateUrl: './cities.component.html',
  styleUrls: ['./cities.component.scss'],
})
export class CitiesComponent implements OnInit {
  data: any[] = [];
  pag: number = 1;
  type = 'countries';
  dataCountry: any[] = [];

  constructor(
    private adminSv: AdminServiceService,
    private uiSv: UiService,
  ) { }

  ngOnInit() {
    this.loadData();
  }

  
  async changePag(i) {
    if(i){
      this.pag = this.pag + 1;
    }else{
      if(this.pag === 1){
        return;
      }
      this.pag = this.pag - 1;
    }
    this.loadData();
  }

  loadData(){
    this.adminSv.getAllLocation(this.pag).subscribe((res: any) => {
      this.data = res.data.data;
    })

    this.adminSv.getAllCountry(this.pag, '', 'index').subscribe((res: any) => {
      this.dataCountry = res.data.data;
    })
  }

  async createLocation(edit?, isState = true){
    try{
      const { data, role } = await this.uiSv.createModal(
        LocationComponent,
        { 
          edit, 
          showCity: isState,
          countries: isState ? this.dataCountry : []
        }, '', true
      );
      let index = undefined;
      if(role === 'update' || role === 'destroy'){
        const indexItem = 
          isState 
            ? this.data.findIndex(item => item.id === (data.id || data)) 
            : this.dataCountry.findIndex(item => item.id === (data.id || data));
            index = indexItem;
        this.loadData();
      }
    }catch(err){
      console.error(err);
    }
  }
}
